export const moveListItemBack = (arr: any[], index: number) => {
  if (index < 0 || index >= arr.length - 1) {
    console.log('Invalid index.');
    return arr;
  }

  const item = arr.splice(index, 1)[0];
  arr.splice(index + 1, 0, item);

  return arr;
};

export const getNumberToString = (str: string) => {
  const numbersOnly = str.replace(/\D/g, '');
  return numbersOnly;
};

export const moveItemForward = (arr: any[], index: number) => {
  if (index <= 0 || index >= arr.length) {
    console.log('Invalid index.');
    return arr;
  }

  const item = arr.splice(index, 1)[0];
  arr.splice(index - 1, 0, item);

  return arr;
};

export const formatPhoneNumber = (phoneNumber: string) => {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  let formatted = cleaned;
  if (cleaned.length === 9) formatted = cleaned.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
  else if (cleaned.length === 10) formatted = cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  else formatted = cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  return formatted;
};

export const getProductName = (product: any, lang: number) => {
  if (lang === 0) return product.product_name;
  else if (lang === 1) return product.product_name_en;
  else if (lang === 2) return product.product_name_ch;
  else if (lang === 3) return product.product_name_ja;
  else if (lang === 4) return product.product_name_th;
  else if (lang === 5) return product.product_name_es;
  else if (lang === 6) return product.product_name_fr;
  else if (lang === 7) return product.product_name_ru;
  else if (lang === 8) return product.product_name_de;
  else return product.product_name;
};
export const getOptionName = (option: any, lang: number) => {
  if (lang === 0) return option.option_name;
  else if (lang === 1) return option.option_name_en;
  else if (lang === 2) return option.option_name_ch;
  else if (lang === 3) return option.option_name_ja;
  else if (lang === 4) return option.option_name_th;
  else if (lang === 5) return option.option_name_es;
  else if (lang === 6) return option.option_name_fr;
  else if (lang === 7) return option.option_name_ru;
  else if (lang === 8) return option.option_name_de;
  else return option.option_name;
};
export const getOptionTypeName = (option: any, lang: number) => {
  if (lang === 0) return option.option_type_name;
  else if (lang === 1) return option.option_type_name_en;
  else if (lang === 2) return option.option_type_name_ch;
  else if (lang === 3) return option.option_type_name_ja;
  else if (lang === 4) return option.option_type_name_th;
  else if (lang === 5) return option.option_type_name_es;
  else if (lang === 6) return option.option_type_name_fr;
  else if (lang === 7) return option.option_type_name_ru;
  else if (lang === 8) return option.option_type_name_de;
  else return option.option_type_name;
};
export const getCancelDescription = (cancel: any, lang: number) => {
  const translations: any = {
    '고객 취소': [
      '고객 취소',
      'Customer Cancellation',
      '客户取消',
      '顧客キャンセル',
      'การยกเลิกจากลูกค้า',
      'Cancelación del cliente',
      'Annulation par le client',
      'Отмена клиентом',
      'Kundenstornierung',
    ],
    '가게 사정': [
      '가게 사정',
      'Store Circumstances',
      '商店情况',
      '店舗の事情',
      'สถานการณ์ของร้าน',
      'Circunstancias de la tienda',
      'Circonstances du magasin',
      'Обстоятельства магазина',
      'Umstände des Geschäfts',
    ],
    '조리 지연': [
      '조리 지연',
      'Cooking Delay',
      '烹饪延迟',
      '調理の遅延',
      'การชะลอการปรุง',
      'Retraso en la cocina',
      'Retard de cuisson',
      'Задержка приготовления',
      'Kochverzögerung',
    ],
    '요청사항 적용 불가': [
      '요청사항 적용 불가',
      'Request Cannot Be Applied',
      '请求无法应用',
      'リクエストは適用できません',
      'ไม่สามารถใช้คำขอได้',
      'No se puede aplicar la solicitud',
      'Demande non applicable',
      'Запрос не может быть применен',
      'Anfrage kann nicht angewendet werden',
    ],
    '배달원 부재': [
      '배달원 부재',
      'Delivery Person Absent',
      '送货员缺席',
      '配達員不在',
      'พนักงานส่งของไม่อยู่',
      'Repartidor ausente',
      'Livreur absent',
      'Курьер отсутствует',
      'Lieferperson abwesend',
    ],
    '재료 소진': [
      '재료 소진',
      'Out of Ingredients',
      '材料用尽',
      '材料がなくなりました',
      'วัตถุดิบหมด',
      'Ingredientes agotados',
      'Ingrédients épuisés',
      'Ингредиенты закончились',
      'Zutaten erschöpft',
    ],
    '고객 요청': [
      '고객 요청',
      'Customer Request',
      '客户请求',
      '顧客のリクエスト',
      'คำขอจากลูกค้า',
      'Solicitud del cliente',
      'Demande du client',
      'Запрос клиента',
      'Kundenanfrage',
    ],
  };

  const description = cancel.cancel_description;
  return translations[description] ? translations[description][lang] : description;
};
export const getPickupName = (pickup: any, lang: number) => {
  if (lang === 0) return pickup.pickup_name;
  else if (lang !== 0) return pickup.pickup_name_en;
  else return pickup.pickup_name;
};

export const focusInput = (value: string) => {
  const inputElement = document.getElementById(value);
  if (inputElement) {
    const offsetPosition = inputElement.getBoundingClientRect().top + window.scrollY - 120;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};
